module.exports = __webpack_public_path__ + "static/media/default.3456bd7b.jpg";